/* global app */

var groupMapping = {
  "VIRTUALATTENDEES": "Teilnehmer*innen",
  "REAL": "Standard"
}

var eventStatusMapping = {
  0: "nicht veröffentlicht",
  1: "veröffentlicht"
}

var foodStateMapping = {
  0: "nicht aktiviert",
  1: "aktiviert"
}

var permissionLevelMapping = {
  1: "lesen",
  2: "verwalten",
  3: "admin"
}

var accountActivationStateMapping = {
    1: 'freigeschalten',
    0: 'nicht freigeschalten'
}

var templateTypeMapping = {
  "SHIFTREGISTER": "Bei Schicht registriert",
  "SHIFTACCEPT": "Schicht wurder akzeptiert",
  "SHIFTDECLINE": "Schicht wurde abgelehnt",
  "SHIFTADDFROMADMIN": "User wurde zur Schicht hinzugefügt"
}

//=============================

var collectionTypes = {
  "groupMapping":groupMapping,
  "eventStatusMapping":eventStatusMapping,
  "permissionLevelMapping": permissionLevelMapping,
  "accountActivationStateMapping": accountActivationStateMapping,
  "foodStateMapping": foodStateMapping,
  "templateTypeMapping": templateTypeMapping
  
}

app.filter('acMapFilter', ['$filter',function myDateFormat($filter){
  return function(text, collectionType){
    var collection = collectionTypes[collectionType];
    var mappedString = collection[text];
    if(mappedString == undefined){
      console.error("mapFilter failed mapping "+text+" with '"+collectionType+"'")
    }
    return mappedString;
  }
}]);
